import { ref, readonly } from 'vue'

// State
export const isCopied = ref(false)
export const isClipboardSupported = ref(!!navigator.clipboard)

// Readonly exports for public use
export const readonlyIsCopied = readonly(isCopied)
export const readonlyIsClipboardSupported = readonly(isClipboardSupported)
